import { IconProps } from "./types";

// Native aspect ratio of the design spec's SVG — non-square, so `size` maps
// to width and height is derived to avoid distorting the glyph.
const VIEWBOX_WIDTH = 9;
const VIEWBOX_HEIGHT = 15;

/**
 * Solid two-tone down arrow (arrowhead + base line) used by Order Details'
 * Dropoff row icon (see `StopIcon`). Deliberately its own glyph rather than
 * a reuse of `ArrowDownIcon` (the map's DropoffMarker arrow) — close in
 * spirit, but a different shape/viewBox from a separate design spec.
 *
 * The source SVG wrapped both paths in a `<clipPath>` matching the
 * viewBox bounds; dropped here since the viewBox already clips overflow the
 * same way, and multiple Dropoff rows rendering this icon at once would
 * otherwise collide on the same literal `id="a"`.
 */
export const DropoffArrowIcon = ({ size = VIEWBOX_WIDTH, color = "currentColor", className }: IconProps) => {
  const height = size * (VIEWBOX_HEIGHT / VIEWBOX_WIDTH);

  return (
    <svg
      width={size}
      height={height}
      viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.342 10.356a.7.7 0 0 1-.492-.2L.843 7.187a.673.673 0 0 1 .001-.964.703.703 0 0 1 .982.001l1.823 1.8V2.5c0-.376.31-.682.693-.682s.694.306.694.682v5.524l1.825-1.8a.7.7 0 0 1 .981-.001.673.673 0 0 1 .002.964l-2.992 2.95a.7.7 0 0 1-.51.22"
        fill={color}
      />
      <path
        opacity=".4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.996 12.727H.694A.69.69 0 0 1 0 12.045c0-.376.31-.682.694-.682h7.302c.383 0 .694.306.694.682s-.311.682-.694.682"
        fill={color}
      />
    </svg>
  );
};
